"use client";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { Floodlight } from "../../Lib/Analytics/floodlight";

/**
 * Reports App Router navigations to Floodlight. The app never does a full
 * page load between routes, so "user reached page X" has to be derived from
 * the pathname rather than from a document load. Renders nothing.
 */
export default function FloodlightPageTracker() {
  const pathname = usePathname();
  useEffect(() => {
    if (pathname) Floodlight.pageView(pathname);
  }, [pathname]);
  return null;
}
